export const SEED = {
  users: [
    { id: "parent", name: "Parent", role: "parent", pin: "1234",       avatar: "🏠", theme: "slate",    bgImage: null, lastActive: null },
    { id: "child1", name: "Maisha", role: "child",  yearLevel: 8, pin: "1234", mustResetPin: true, avatar: "🌸", theme: "ocean",  bgImage: null, lastActive: null },
    { id: "child2", name: "Aariv",  role: "child",  yearLevel: 6, pin: "1234", mustResetPin: true, avatar: "⚡", theme: "sunset", bgImage: null, lastActive: null },
  ],
  wordLists: [
    {
      id: "list1", name: "Week 3 — Term 2", yearLevel: 8, difficulty: "hard", dailyCount: 10, active: true,
      words: [
        { id: "w1", word: "accommodation" }, { id: "w2", word: "conscientious" },
        { id: "w3", word: "exaggerate" },    { id: "w4", word: "Mediterranean" },
        { id: "w5", word: "particularly" },  { id: "w6", word: "occasionally" },
        { id: "w7", word: "perseverance" },  { id: "w8", word: "recommend" },
        { id: "w9", word: "privilege" },     { id: "w10", word: "rhythm" },
      ]
    },
    {
      id: "list2", name: "Week 3 — Term 2", yearLevel: 6, difficulty: "medium", dailyCount: 8, active: true,
      words: [
        { id: "w11", word: "necessary" },  { id: "w12", word: "receive" },
        { id: "w13", word: "separate" },   { id: "w14", word: "believe" },
        { id: "w15", word: "achieve" },    { id: "w16", word: "beginning" },
        { id: "w17", word: "beautiful" },  { id: "w18", word: "environment" },
        { id: "w19", word: "government" }, { id: "w20", word: "immediately" },
      ]
    }
  ],
  progress: {}, meaningProgress: {}, synProgress: {}, antProgress: {},
  sessions: [],
  notifications: [], goals: {}, savedBonuses: [], savedDeductions: [],
  streaks: { child1: 0, child2: 0 },
  badges: { child1: [], child2: [] },
  points: { child1: 0, child2: 0 },
  rewards: [
    { id: "r1", name: "30 mins extra screen time", cost: 50,  emoji: "📱" },
    { id: "r2", name: "Choose dinner",              cost: 100, emoji: "🍕" },
    { id: "r3", name: "Movie night pick",           cost: 150, emoji: "🎬" },
    { id: "r4", name: "Sleep in on weekend",        cost: 200, emoji: "😴" },
  ],
  requests: [],
  quizDrafts: {},
  appName: "SpellWise Kids",
};
